import * as React from 'react';
import { Controller, Loader, IDynamicLoader, ListItem } from '@tencent/workbench';
import { FORM_CONFIGS } from './config';
import { Form } from '@tencent/wb-ext-form';
import { FormItemName } from '@framework/workbench/drawer/constants';
import { IFontFamilyThemeFeature } from './font-family-theme-interface';
import { getFontFamilyConfigData } from '@src/framework/editor/src/js/constants/toolbar-data';

@Controller({ formItems: FORM_CONFIGS })
export class FontFamilyThemeFormController {
    constructor(@Loader(IFontFamilyThemeFeature) private loader: IDynamicLoader<IFontFamilyThemeFeature>) {}

    private get feature() {
        return this.loader.instance!;
    }

    @Form(FormItemName.FONT_THEME, 'content')
    public renderFontFamily() {
        return this.feature.renderFontFamily();
    }

    @Form(FormItemName.FONT_THEME, 'shouldHide')
    public shouldHideFontTheme(): boolean {
        return !this.feature.isMasterEditType;
    }
}
